"use strict";
(self.webpackChunkdemel_shopify_template = self.webpackChunkdemel_shopify_template || []).push([
    [505], {
        774: (e, t, n) => {
            n.r(t);
            var s = n(9394),
                o = n(6377),
                i = n(2908),
                r = n(4412),
                c = n(4667);
            (0, s.$e)((() => {
                const e = document.documentElement,
                    t = +e.getBoundingClientRect().width.toFixed(2);
                e.style.setProperty("--scrollbar-width", "" + (window.innerWidth - t));
                const n = (0, o.Ds)((() => {
                    e.style.setProperty("--vh", .01 * visualViewport.height + "px")
                }), 32);
                visualViewport.addEventListener("resize", n), n()
            })), (0, i.p)("load", window, (() => {
                (0, s.$e)((() => {
                    const e = (0, r.go)("form.js-klaviyo-form");
                    for (const t of e)(0, i.p)("submit", t, (async e => {
                        e.preventDefault();
                        const n = e.submitter?.textContent || "";
                        let s;
                        e.submitter && (e.submitter.textContent = "Submitting...");
                        try {
                            const e = new FormData(t);
                            e.set("$timezone_offset", "" + (new Date).getTimezoneOffset() / -60), e.set("services", JSON.stringify({
                                shopify: {
                                    source: "form"
                                }
                            })), s = await fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
                                method: "POST",
                                body: e
                            }).then((e => e.json()))
                        } catch {}
                        s?.success && (t.insertAdjacentHTML("beforebegin", '<p class="text-zeta text-center">Thank you.<br>Please check your email inbox.</p>'), t.hidden = !0), e.submitter && (e.submitter.textContent = n)
                    }))
                })), (0, s.$e)((() => {
                    const e = (0, r.go)("#insta-feed");
                    if (!e.length) return;
                    let t, n = 0;
                    const s = e => {
                        if (clearTimeout(t), e && "" === e.firstElementChild?.className && e.firstElementChild?.childElementCount) {
                            const t = document.createElement("div");
                            return t.classList.add("c-slider__track"), e.querySelectorAll(".slide-page").forEach((e => {
                                e.classList.add("c-slider__slide"), t.append(e)
                            })), e.firstElementChild?.insertAdjacentElement("afterbegin", t), e.firstElementChild?.classList.add("c-slider__viewport", "js-slider-viewport"), void window.initSlider(e)
                        }
                        n += 1, t = setTimeout((() => s(e)), 200 * n ** 2)
                    };
                    for (const t of e) c.N7(t.closest(".shopify-section") ?? t, ((e, {
                        target: n
                    }) => {
                        e && (window.Shopify.loadAppScript("instaFeed"), s(t), c.p_(n))
                    }), {
                        rootMargin: "250px 0px"
                    })
                }))
            }), {
                once: !0
            })
        },
        2908: (e, t, n) => {
            function s(e, t, n, s) {
                return t || (t = document), t.addEventListener(e, n, s), () => t.removeEventListener(e, n, s)
            }
            n.d(t, {
                p: () => s
            })
        },
        4667: (e, t, n) => {
            n.d(t, {
                N7: () => c,
                p_: () => a
            });
            const s = new Map,
                o = new Map,
                i = new Map;
            let r = 0;

            function c(e, t, n = {}) {
                const {
                    root: c,
                    rootMargin: a,
                    threshold: d = 0
                } = n;
                if (!e) return;
                const u = function(e) {
                    return e ? i.has(e) ? i.get(e) : (r += 1, i.set(e, r.toString()), `${i.get(e)}_`) : ""
                }(c) + (a ? `${d.toString()}_${a}` : d.toString());
                let m = o.get(u);
                m || (m = new IntersectionObserver(l, n), u && o.set(u, m));
                const f = {
                    callback: t,
                    element: e,
                    inView: !1,
                    observerId: u,
                    observer: m,
                    thresholds: m.thresholds || (Array.isArray(d) ? d : [d])
                };
                return s.set(e, f), m.observe(e), f
            }

            function a(e) {
                if (!e) return;
                const t = s.get(e);
                if (t) {
                    const {
                        observerId: n,
                        observer: o
                    } = t, {
                        root: r
                    } = o;
                    o.unobserve(e);
                    let c = !1,
                        a = !1;
                    n && s.forEach(((t, s) => {
                        s !== e && (t.observerId === n && (c = !0, a = !0), t.observer.root === r && (a = !0))
                    })), !a && r && i.delete(r), o && !c && o.disconnect(), s.delete(e)
                }
            }

            function l(e) {
                e.forEach((e => {
                    const {
                        isIntersecting: t,
                        intersectionRatio: n,
                        target: o
                    } = e, i = s.get(o);
                    if (i && n >= 0) {
                        let s = i.thresholds.some((e => i.inView ? n > e : n >= e));
                        void 0 !== t && (s = s && t), i.inView = s, i.callback(s, e)
                    }
                }))
            }
        },
        6377: (e, t, n) => {
            n.d(t, {
                Ds: () => o,
                P2: () => s
            });
            const s = (e, t) => {
                    let n, s, o;
                    return function(...i) {
                        const r = this;
                        n ? (clearTimeout(s), s = setTimeout((() => {
                            Date.now() - o >= t && (e.apply(r, i), o = Date.now())
                        }), Math.max(t - (Date.now() - o), 0))) : (e.apply(r, i), o = Date.now(), n = !0)
                    }
                },
                o = (e, t = 0) => {
                    let n;
                    return function(...s) {
                        clearTimeout(n), n = setTimeout((() => e.apply(this, s)), t)
                    }
                }
        }
    }
]);